import { Hex } from 'viem';
import { api } from '../api';
import { RedirectUrlResponse } from '../../types/redirect-url';

export const WalletLoginApi = {
  getWalletMessage: async (wallet: string) => {
    const { data } = await api.get<{ message: string }>(`/walletlogin/${wallet}/message`);

    return data.message;
  },
  signIn: async (wallet: string, body: { signature: Hex }) => {
    const { data } = await api.post<RedirectUrlResponse>(`/walletlogin/${wallet}/signin?sign_in=true`, body);

    return data;
  },
  signUp: async (wallet: string, body: { signature: Hex }) => {
    const { data } = await api.post<RedirectUrlResponse>(`/walletlogin/${wallet}/signin?sign_in=false`, body);

    return data;
  },
};
